module.exports = __webpack_public_path__ + "img/contactless.af1af7d4.svg";